import React from "react";
import { TimePicker as AntdTimePicker } from "../../antdMoment";
import moment from "../../moment";
import useLocale from "../DatePicker/useLocale";

export const TIME_SHORT_FORMAT = "HH:mm";

export const formatDateToTime = (date, format = TIME_SHORT_FORMAT) => {
  return date ? moment(date).format(format) : date;
};

const TimePicker = (props) => {
  const locale = useLocale();
  const { format = TIME_SHORT_FORMAT, value, ...rest } = props;
  return (
    <AntdTimePicker format={format} size="large" locale={locale} value={value ? moment(value) : value} {...rest} />
  );
};

export default TimePicker;
